import { EmailSettings, ScheduleSubscriptionFacade } from '@mode/shared/schedules/contract';

export class ScheduleSubscriptionFacadeService extends ScheduleSubscriptionFacade {
  public settingsChanged(
    subscription: {
      data_previews_enabled: boolean;
      data_tables_enabled: boolean;
      report_links_enabled: boolean;
      csv_attachments_enabled: boolean;
      pdf_attachments_enabled: boolean;
    },
    scheduleModalFacade: { hasUpdate: boolean },
    selected: EmailSettings
  ): void {
    subscription.data_previews_enabled = selected.previewImages;
    subscription.data_tables_enabled = selected.tablesOfRawData;
    subscription.report_links_enabled = selected.urlLinks;
    subscription.csv_attachments_enabled = selected.csv;
    subscription.pdf_attachments_enabled = selected.pdf;
    scheduleModalFacade.hasUpdate = true;
  }
}
